import { faHeartPulse, faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UnsupportedChainIdError, useWeb3React } from '@web3-react/core';
import React from 'react';
import styled from 'styled-components';
import WalletModal from '../../../../components/WalletModal';
import { NetworkContextName } from '../../../../constants';
import { useActiveWeb3React } from '../../../../hooks';
import { useWalletModalToggle } from '../../../../state/application/hooks';
import { isTransactionRecent, useAllTransactions } from '../../../../state/transactions/hooks';
import { TransactionDetails } from '../../../../state/transactions/reducer';
import { shortenAddress } from '../../../../utils';
import NFTButton from '../../newComponents/NFTButton';

const Text = styled.p`
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 0.5rem 0 0.25rem;
  font-size: 0.8rem;
  width: fit-content;
  font-weight: 500;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 12px;
  `}
`
function newTransactionsFirst(a: TransactionDetails, b: TransactionDetails) {
    return b.addedTime - a.addedTime
}

const WalletStatus = () => {
    const { account, active, error } = useActiveWeb3React()
    const toggleWalletModal = useWalletModalToggle()
    const contextNetwork = useWeb3React(NetworkContextName)

    const allTransactions = useAllTransactions()

    const sortedRecentTransactions = React.useMemo(() => {
        const txs = Object.values(allTransactions)
        return txs.filter(isTransactionRecent).sort(newTransactionsFirst)
    }, [allTransactions])

    const pending = sortedRecentTransactions.filter(tx => !tx.receipt).map(tx => tx.hash)
    const confirmed = sortedRecentTransactions.filter(tx => tx.receipt).map(tx => tx.hash)

    if (!contextNetwork.active && !active) {
        return null
    }

    const renderContent = () => {
        if (account) {
            return (
                <NFTButton>
                    <Text>{shortenAddress(account)}</Text>
                </NFTButton>
            )
        } else if (error) {
            return (
                <NFTButton>
                    <FontAwesomeIcon icon={faHeartPulse} size={"1x"} />
                    <Text>{"Connect Wallet"}</Text>
                    <Text>{error instanceof UnsupportedChainIdError ? 'Unsupported Network' : 'Error'}</Text>
                </NFTButton>
            )
        } else {
            return (
                <NFTButton>
                    <FontAwesomeIcon icon={faWallet} size={"1x"} /><Text>{"Connect Wallet"}</Text>
                </NFTButton>
            )
        }
    }

    return (
        <div onClick={toggleWalletModal}>
            {renderContent()}
            <WalletModal ENSName={undefined} pendingTransactions={pending} confirmedTransactions={confirmed} />
        </div>
    )
}

export default WalletStatus;